import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, firstValueFrom, map } from "rxjs";
import { IBandejaTareas } from "../../interfaces/bandeja";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class BandejaService {
  constructor(private http: HttpClient) {}
 
  obtenerBandeja(
    sessionId: string,
    sessionRol: number
  ): Promise<any> {
    return firstValueFrom(
      this.http.post(`${environment.entregables.obtener}`, {
        sessionId,
        sessionRol,
      })
    );
  }
}
